var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.18173 12.2128c0-.6486.10773-1.2705.3-1.8538l-3.36546-2.56994c-.6559 1.33175-1.02545 2.83234-1.02545 4.42374 0 1.59.36909 3.0897 1.02409 4.4205l3.36364-2.575c-.19046-.5805-.29682-1.2001-.29682-1.8455z",
    fill: "#fbbc05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.0908 6.31204c1.409 0 2.6818.49929 3.6818 1.31631l2.9091-2.90497c-1.7728-1.54326-4.0455-2.49645-6.5909-2.49645-3.95186 0-7.34823 2.25997-8.97459 5.5621l3.36546 2.56997c.77545-2.35392 2.9859-4.04696 5.60913-4.04696z",
    fill: "#eb4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.0908 18.1135c-2.62323 0-4.83368-1.693-5.60913-4.047l-3.36546 2.5696c1.62636 3.3025 5.02273 5.5625 8.97459 5.5625 2.439 0 4.7677-.866 6.5154-2.4887l-3.1945-2.4697c-.9014.5678-2.0364.8733-3.3209.8733z",
    fill: "#34a853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m21.6363 12.2127c0-.5901-.0909-1.2255-.2273-1.8156h-9.3182v3.8582h5.3637c-.2682 1.3154-.9982 2.3266-2.0428 2.9848l3.1946 2.4697c1.8359-1.704 3.03-4.2422 3.03-7.4971z",
    fill: "#4285f4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.bda9b93edd5fbfa7e910c43e4df5b4ba.svg";
export { ForwardRef as ReactComponent };